<!--
  @Description 侧边栏组件
  @Date 2021-12-22
  @Author liushuo
-->
<template>
  <div class="navmenu-container">
    <!-- 姓名 -->
    <div class="name-dv" :id="$store.state.userInfo.name.length > 3 ? 'longName' : 'shotName'" @click="handleOpenMes">
      {{ $store.state.userInfo.name }}
    </div>
    <!-- 菜单 -->
    <div class="menu-dv">
      <NavItem
        v-for="(menuItem, index) of menuList"
        :key="index"
        :item="menuItem"
        :navIndex="index"
        :activeIndex="activeIndex"
        @change="changeNav"
      ></NavItem>
    </div>
    <!-- 注销 -->
    <div class="exit-dv" @click="logout">
      <img src="@/assets/img/exit.png" />
    </div>
    <!-- 个人信息弹窗 -->
    <MyMessage ref="MyMessage" />
  </div>
</template>

<script>
import NavItem from './NavItem'
import MyMessage from '../common/myMessageSelect.vue'
export default {
  components: {
    NavItem,
    MyMessage
  },
  created() {
    this.createMenu()
  },
  mounted() {
    this.setDefaultActiveIndex()
  },
  data() {
    return {
      // 默认当前选中菜单
      activeIndex: 0,
      // 菜单列表
      menuList: []
    }
  },
  methods: {
    // 动态创建菜单
    createMenu() {
      this.menuList = []
      let createMenu = item => {
        if (item.children) {
          for (let itemDetail of item.children) {
            createMenu(itemDetail)
          }
        } else {
          switch (item.name) {
            case '系统日志':
              item.icon = require('@/assets/img/nav-log-icon.png')
              break
            case '需求登记':
              item.icon = require('@/assets/img/nav-4.png')
              break
            case '用户设置':
            case '人员档案':
              item.icon = require('@/assets/img/nav-6.png')
              break
            case '模块菜单':
              item.icon = require('@/assets/img/nav-menu.png')
              break
            case '基础设置':
              item.icon = require('@/assets/img/nav-1.png')
              break
            case '数据处理':
              item.icon = require('@/assets/img/nav-handle.png')
              break
            case '零星费用':
              item.icon = require('@/assets/img/nav-lx.png')
              break
            case '汇款申请':
              item.icon = require('@/assets/img/nav-hk.png')
              break
            case '差旅费用':
              item.icon = require('@/assets/img/nav-cl.png')
              break
            case '其他':
              item.icon = require('@/assets/img/nav-wr.png')
              break
            case '报告审批':
              item.icon = require('@/assets/img/nav-ra.png')
              break
            case '邮寄':
              item.icon = require('@/assets/img/nav-mail.png')
              break
            case '报价':
              item.icon = require('@/assets/img/nav-bj.png')
              break
            case '合同模板':
              item.icon = require('@/assets/img/nav-contract.png')
              break
            case '合同管理':
              item.icon = require('@/assets/img/nav-contract-management.png')
              break
          }
          this.menuList.push(item)
        }
      }
      for (let item of this.$store.state.menulist) {
        createMenu(item)
      }
    },
    // 设置侧边栏默认选中的索引
    setDefaultActiveIndex() {
      this.activeIndex = this.$store.state.activeIndex
    },
    // 切换菜单事件
    changeNav(item, index) {
      this.setCurIndex(index)
      this.$emit('changeRouter', item)
    },
    // 设置当前激活索引
    setCurIndex(index) {
      this.activeIndex = index
      this.$store.commit('set_activeIndex', index)
    },
    // 注销账号
    async logout() {
      this.$store.commit('set_logout', true)
      this.setCurIndex(0)

      // window.localStorage.clear()
      window.sessionStorage.clear()
      this.$router.push('/Login')
    },
    // 打开个人信息
    handleOpenMes() {
      this.$refs.MyMessage.formVisible = true
    }
  }
}
</script>

<style lang="less" scoped>
@active-bg-color: #1050af;

@name-height: 55px;
@exit-height: 62px;
@container-width: 80px;

.navmenu-container {
  // ↓ 侧边栏不贴边的样式
  margin-left: 7px;
  margin-top: 10px;
  height: 98%;
  border-radius: 20px;
  // ↑ 侧边栏不贴边的样式
  // ↓ 侧边栏贴边的样式
  // width: 100%;
  // height: 100%;
  // border-radius: 0 10px 10px 0;
  // ↑ 侧边栏贴边的样式
  background-image: linear-gradient(to bottom, #4584e6, #496fdd);
  display: flex;
  flex-direction: column;
  align-items: center;
  transition: all 0.5s ease;
  box-shadow: #528dec 1px 1px 10px;
}
#shotName {
  font-size: 14px;
}
#longName {
  font-size: 12px;
}
.name-dv {
  width: @name-height;
  height: @name-height;
  margin-top: 15px;
  border-radius: 50%;
  font-weight: bold;
  box-shadow: rgba(40, 230, 119, 0.35) 1px 1px 5px;
  background-color: #00d3ba;
  color: #fff;
  .fl;
  transition: @slow-transition;
  text-align: center;
}
.name-dv:hover {
  background-color: #00c5ae;
  cursor: pointer;
  transition: @slow-transition;
}

.menu-dv {
  width: 100%;
  height: calc(100vh - @name-height - @exit-height);
  margin: 20px 0;
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  align-items: center;
  overflow-y: auto;
}

// 隐藏滚动条
.menu-dv::-webkit-scrollbar {
  width: 0 !important;
}

.exit-dv {
  width: 62px;
  height: @exit-height;
  border-radius: 10px;
  margin: 10px 0;
  transition: @normal-transition;
  .fl;

  > img {
    width: 22px;
    height: 22px;
    transform: rotate(180deg);
  }
}

.exit-dv:hover {
  cursor: pointer;
  transition: @normal-transition;
  background-color: #e24949;
}
</style>
